export default "__VITE_ASSET__6smUDXZS__"